// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__z5y4Y","requiredAsterisk":"Info_requiredAsterisk__3rL74"};